import { createReducer, on } from '@ngrx/store';

import * as manageAppsActions from '../actions/manage-apps.actions';
import * as sessionActions from '../actions/session.actions';
import * as actions from '../actions/tags.actions';
import { tagsState } from '../states/tags.state';

export const TAGS_REDUCER_KEY = 'tags';
export const TAGS_REDUCER = createReducer(
    tagsState,
    on(manageAppsActions.SetManageAppsStatus, (state, action) => {
        if (!(action.organizationId?.length > 0)) {
            return state;
        }
        return {
            ...state,
            organizationsMap: {
                ...state.organizationsMap,
                [action.organizationId]: {
                    ...state.organizationsMap?.[action.organizationId],
                    subscriptionStatus: action.subscriptionStatus || 'NOT_SUBSCRIBED',
                },
            },
        };
    }),
    on(actions.SetTagAppsByKeyValues, (state, action) => {
        if (!(action.organizationId?.length > 0)) {
            return state;
        }
        const key = action.tagKey,
            value = action.tagValue,
            status = action.status || state.organizationsMap[action.organizationId].subscriptionStatus;
        return {
            ...state,
            organizationsMap: {
                ...state.organizationsMap,
                [action.organizationId]: {
                    ...state.organizationsMap[action.organizationId],
                    tagKeyValuesVsAppDetails: {
                        ...state.organizationsMap[action.organizationId]?.tagKeyValuesVsAppDetails,
                        [`${key}|${value}|${status}`]: action.apps,
                    },
                },
            },
        };
    }),
    on(sessionActions.SessionLogoutSuccessfull, () => tagsState)
);

